"use client";

import { useState, useCallback } from "react";
import type { KeyboardEvent } from "react";

interface ToggleProps {
  "onClick": () => void;
  "onKeyDown": (event: KeyboardEvent) => void;
  "role": "button";
  "tabIndex": 0;
  "aria-expanded": boolean;
}

interface UseExpandableRowResult {
  expanded: boolean;
  toggleProps: ToggleProps;
}

export function useExpandableRow(): UseExpandableRowResult {
  const [expanded, setExpanded] = useState(false);

  const toggle = useCallback(() => {
    setExpanded((prev) => !prev);
  }, []);

  const onKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        toggle();
      }
    },
    [toggle],
  );

  return {
    expanded,
    toggleProps: {
      "onClick": toggle,
      onKeyDown,
      "role": "button",
      "tabIndex": 0,
      "aria-expanded": expanded,
    },
  };
}
